
$(document).ready(function(){
    
    // matchHeight
 
   
    $('#news .item').matchHeight();
	$('.prestige-category .item-wrapper').matchHeight();
	// $('.details__block-item').matchHeight();
    $('.prestige-category .item-wrapper').matchHeight();
    $('.prestige-category .details-wrapper').matchHeight();
    $("body, html").animate({ scrollTop: 0 }, 1);
    new WOW().init();  
    lazySizes.init();
    $('#scrollTopBtn').click(function(e) {
        e.preventDefault();
              $('html, body').animate({scrollTop:0}, '300');
    })

    // $('body').niceScroll({
	// 	cursorcolor:"#414141",
	// 	cursorwidth:"7px",
	// 	background:"rgba(28, 28, 28, 0.75)",
    //     cursorborder:"1px solid #414141", 
    //     cursorborderradius:0
    // });

    $('.slick-carousel').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        nextArrow: $('.controler--block .right'),
            prevArrow: $('.controler--block .left'),

        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                }
            },
        ]

    });

    if ($(window).width() > 991) {
        // console.log('768')
        $('.block-slider__main').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: false,
            adaptiveHeight: false,
            infinite: false,
            useTransform: true,
            speed: 400,
            accessibility: true,
            cssEase: 'cubic-bezier(0.77, 0, 0.18, 1)',
        });
       
        $('.block-slider__nav')
            .on('init', function(event, slick) {
                $('.block-slider__nav .slick-slide.slick-current').addClass('is-active');
            })
            .slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                dots: false,
                focusOnSelect: false,
                infinite: false,
                arrows: false,
                
                responsive: [
                    {
                        breakpoint: 599,
                        settings : {
                            slidesToShow: 2,
                        
                        }
                    }
                ]
            });
       
        $('.block-slider__main').on('afterChange', function(event, slick, currentSlide) {
            $('.block-slider__nav').slick('slickGoTo', currentSlide);
            var currrentNavSlideElem = '.block-slider__nav .slick-slide[data-slick-index="' + currentSlide + '"]';
            $('.block-slider__nav .slick-slide.is-active').removeClass('is-active');
            $(currrentNavSlideElem).addClass('is-active');
        });
       
        $('.block-slider__nav').on('click', '.slick-slide', function(event) {
            event.preventDefault();
            var goToSingleSlide = $(this).data('slick-index');
       
            $('.block-slider__main').slick('slickGoTo', goToSingleSlide);
            // console.log('yaah')
        });

    }
    // else {
    //     location.reload();
    // }
    $( window ).resize(function() {
        if ($(window).width() > 991) {
            // console.log('992')
            $('.block-slider__main').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                fade: false,
                adaptiveHeight: false,
                infinite: false,
                useTransform: true,
                speed: 400,
                accessibility: true,
                cssEase: 'cubic-bezier(0.77, 0, 0.18, 1)',
            });
           
            $('.block-slider__nav')
                .on('init', function(event, slick) {
                    $('.block-slider__nav .slick-slide.slick-current').addClass('is-active');
                })
                .slick({
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    dots: false,
                    focusOnSelect: false,
                    infinite: false,
                    arrows: false,
                    
                    responsive: [
                        {
                            breakpoint: 599,
                            settings : {
                                slidesToShow: 2,
                            
                            }
                        }
                    ]
                });
           
            $('.block-slider__main').on('afterChange', function(event, slick, currentSlide) {
                $('.block-slider__nav').slick('slickGoTo', currentSlide);
                var currrentNavSlideElem = '.block-slider__nav .slick-slide[data-slick-index="' + currentSlide + '"]';
                $('.block-slider__nav .slick-slide.is-active').removeClass('is-active');
                $(currrentNavSlideElem).addClass('is-active');
            });
           
            $('.block-slider__nav').on('click', '.slick-slide', function(event) {
                event.preventDefault();
                var goToSingleSlide = $(this).data('slick-index');
           
                $('.block-slider__main').slick('slickGoTo', goToSingleSlide);
                // console.log('yaah')
            });

        }
        // else {
        //     location.reload();
        // }
    });
    
    

    $('.map-block__panel .panel-title').on('click', function() {

        if($('.panel-title').hasClass('active')){
            $('.panel-title').removeClass('active');

        }
        else {
        $('.panel-title').addClass('active');
        }
    });

    $('.panel-heading').on('click', function() {
        $('.block-slider__main, .block-slider__nav').slick('refresh');
    });
    $(".popup-gallery__wrapper").each(function () {
        $(this).magnificPopup({
           delegate: ".popup-image",
            type: "image",
            removalDelay: 300,
            mainClass: "mfp-fade",
            gallery: {
                enabled: true
            },
            image: {
                titleSrc: "title"
            }
        });
    });
       $(".popup-gallery-wrapper").each(function () {
        $(this).magnificPopup({
           delegate: ".popup-image-item",
            type: "image",
            removalDelay: 300,
            mainClass: "mfp-ready",
            gallery: {
                enabled: true
            },
            image: {
                titleSrc: "title"
            }
        });
    });
    $("a.popup-image-s").magnificPopup({
        type: 'image',
        removalDelay: 300,
        mainClass: 'mfp-with-zoom',
        zoom: {
            enabled: true, // By default it's false, so don't forget to enable it

            duration: 300, // duration of the effect, in milliseconds
            easing: 'ease-in-out', // CSS transition easing function

            // The "opener" function should return the element from which popup will be zoomed in
            // and to which popup will be scaled down
            // By defailt it looks for an image tag:
            opener: function (openerElement) {
                // openerElement is the element on which popup was initialized, in this case its <a> tag
                // you don't need to add "opener" option if this code matches your needs, it's defailt one.
                return openerElement.is('img') ? openerElement : openerElement.find('img');
            }
        },
        image: {
            // titleSrc: "title"
            titleSrc: function(item) {
                return item.el.parents('div').find('p').html();
                }
        }
    });
        $("a.popup-image").magnificPopup({
        type: 'image',
        removalDelay: 300,
        mainClass: 'mfp-with-zoom',
        zoom: {
            enabled: true, // By default it's false, so don't forget to enable it

            duration: 300, // duration of the effect, in milliseconds
            easing: 'ease-in-out', // CSS transition easing function

            // The "opener" function should return the element from which popup will be zoomed in
            // and to which popup will be scaled down
            // By defailt it looks for an image tag:
            opener: function (openerElement) {
                // openerElement is the element on which popup was initialized, in this case its <a> tag
                // you don't need to add "opener" option if this code matches your needs, it's defailt one.
                return openerElement.is('img') ? openerElement : openerElement.find('img');
            }
        },
       image: {
             titleSrc: function(item) {
                    return item.el.parents('figure').find('p').html();
                }
        }
    });

    $(function(){
        var hash = window.location.hash;
        hash && $('ul.nav a[href="' + hash + '"]').tab('show');
      
        $('.nav-tabs a').click(function (e) {
          $(this).tab('show');
          var scrollmem = $('body').scrollTop() || $('html').scrollTop();
          window.location.hash = this.hash;
          $('html,body').scrollTop(scrollmem);
        });
      });

      $('.advance-option').on('click', function() {
          
          if($('.search-action-area').hasClass('sp')){
            $('.search-action-area').removeClass('sp');
              
          }
          else {
            $('.search-action-area').addClass('sp');

          }
      });

      $(window).scroll(function() {    
        var scroll = $(window).scrollTop();
    
        if(scroll >= 100) {
            $('.scrollbutton').show();
        } else {
            $('.scrollbutton').hide();
            
        }
    });

    // $(".cancel-icon").click(function(e) {
    //     e.preventDefault();
    //     $(".cookies-wrapper").fadeOut(800, 0);
    //     localStorage.setItem("cookie_policy", true);
    // });
    $(".close-cp").click(function(e) {
        e.preventDefault();
        $(".cookies-wrapper").fadeOut(800, 0);
        $('body').removeClass('show-cookies');
        localStorage.setItem("cookie_policy", true);
    });
    if (localStorage.getItem("cookie_policy") == 'true') {
        $('.cookies-wrapper').hide();
        $('body').removeClass('show-cookies');
    }else{
        $('.cookies-wrapper').show();
        $('body').addClass('show-cookies');
    }

    $('.ads-slick-mutiple').slick({
        lazyLoad: 'ondemand',
        centerMode: true,
        slidesToShow: 1,
        centerPadding: '250px',
        infinite: true,
        draggable: true,
        speed: 400,
        autoplay: true,
        responsive: [
        {
        breakpoint: 1199,
        settings: {
            lazyLoad: 'ondemand',
            centerMode: false,
            slidesToShow: 3,
            centerPadding: '0',
            infinite: true,
            draggable: true,
            speed: 400,
            autoplay: true,
        }
    },
    {
    breakpoint: 768,
    settings: {
        centerMode: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        draggable: true,
        speed: 400,
        autoplay: true,
        centerPadding: '0px',
    }
    },
    {
    breakpoint: 480,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      draggable: true,
      speed: 400,
      autoplay: true,
      centerPadding: '0px',
    }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
    ]
    });

    $('.node-type-article .main__slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        infinite: false,
        asNavFor: '.nav__slider',
        nextArrow: $('.node-type-projects .slick-arrow.right, .node-type-article .slick-arrow.right'),
        prevArrow: $('.node-type-projects .slick-arrow.left, .node-type-article .slick-arrow.left'),
      });
      $('.node-type-article .nav__slider').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: '.main__slider',
        infinite: false,
        arrows: false,
        // dots: true,
        // centerMode: true,
        focusOnSelect: true
      });


});

